import RecordableTrack from './RecordableTrack.js';
import SoundUploader from 'api/SoundUploader.js';
import {AUDIO} from 'constants/track-types.js';

class AudioTrack extends RecordableTrack {
    constructor(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence);
        this.setupEffects();
    }

    get selectedRecording() {
        return this.trackData.selectedRecording;
    }

    set selectedRecording(x) {
        this.trackData.selectedRecording = x;
    }

    isRecorable() {
        return true;
    }

    getCopy() {
        let track = super.getCopy((a,b,c,d,e,f) => new AudioTrack(a,b,c,e,d,e,f));
        track.selectedRecording = this.selectedRecording;
        return track;
    }

    getName() {
        return "Audio Track";
    }

    getSelectedRecording() {
        return this.selectedRecording;
    }

    setSelectedRecording(recording) {
        this.selectedRecording = recording;
    }

    getRecordings() {
        return super.getSamplers();
    }

    getJson() {
        let json = super.getJson();
        json.selectedRecording = this.selectedRecording;
        return json;
    }

    fromJson(json) {
        this.selectedRecording = json.selectedRecording;
    }

    getSelectedRecordingSampler() {
        return super.getSamplers()[this.selectedRecording];
    }

    getSelectedRecordingSoundId() {
        return this.soundIds[this.selectedRecording];
    }

    getSamplers() {
        // todo: filter based on what recording should be played
        let samplers = super.getSamplers();
        if (samplers.length > 0) {
            return [samplers[this.selectedRecording]];
        }

        return samplers;
    }

    getTrackType() {
        return AUDIO;
    }
}

export default AudioTrack;
